import DepsService from 'services/dependencies';
import capitalizeWords from 'utils/capitalize-words';

const CONTEXT = 'multistore';

export const fetchRetailerDetails = async (retailerId) => {
  const { url } = DepsService.rest.multiStore.shortRetailerInfo;
  const queryParams = {};
  const urlParams = { retailerId };

  const { retailer } = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);

  const { retailerType, displayNumber, storeNumber, zipCode, phone, state, city, businessName, street1 } = retailer;

  return {
    retailerType,
    displayNumber,
    storeNumber,
    zipCode,
    phone,
    state,
    city: capitalizeWords(city),
    businessName: capitalizeWords(businessName),
    street1: capitalizeWords(street1),
  };
};

const changeLocation = (retailerId, userId) => {
  const { url } = DepsService.rest.multiStore.select;
  const queryParams = { userId };
  const payload = { retailerId };

  return DepsService.restSrv.update(CONTEXT, url, payload, queryParams);
};

export default {
  fetchRetailerDetails,
  changeLocation,
};



// WEBPACK FOOTER //
// ./src/modules/utils/resources/utils.api.js